import { jsx as _jsx } from "react/jsx-runtime";
export const wireFlowIdFromParams = WrappedComponent => props => {
  const {
    flowId: stringId
  } = props.overrideParams || props.match.params;
  const flowId = Number(stringId);
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    flowId: flowId
  }));
};